export default "__VITE_ASSET__7f15bb23__"